import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/energebasic',
    name: 'POST_ENERGEBASIC',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
